import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PatchTask } from '../../redux/taskSlice';
import { Menu, MenuTrigger, MenuPopover, MenuList } from '@fluentui/react-components';
import styles from './css/index.module.css';

const UserAssignmentMenu = ({ task, onUserSelect, children }) => {
    const dispatch = useDispatch();
    const { projectUsersAll } = useSelector(state => state.team);
    const [open, setOpen] = useState(false);

    const handleUserClick = async user => {
        if (!task?.id) return;
        try {
            await dispatch(
                PatchTask({
                    body: { assigned_to: user.value.user_id },
                    id: task.id,
                    suppressToast: true,
                }),
            );
            onUserSelect?.(user);
            setOpen(false);
        } catch (error) {
            console.error('Error updating task assignment:', error);
        }
    };

    return (
        <Menu open={open} onOpenChange={(e, data) => setOpen(data.open)}>
            <MenuTrigger>{children}</MenuTrigger>
            <MenuPopover>
                <MenuList>
                    {/* Unassign Option */}
                    {/* <div onClick={handleUnassign} className={styles.tagMenuItem}>
                        <span>Unassign</span>
                    </div>

                    <MenuDivider /> */}

                    {/* Project Users List */}
                    {projectUsersAll && projectUsersAll.length > 0 ? (
                        projectUsersAll
                            .filter(user => user.value && user.value.user_id)
                            .map(user => (
                                <div key={user.value.user_id} onClick={() => handleUserClick(user)} className={styles.tagMenuItem}>
                                    <span>{user.value.full_name}</span>
                                </div>
                            ))
                    ) : (
                        <div>
                            <p>No users available</p>
                        </div>
                    )}
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default UserAssignmentMenu;
